<template>
  <div id="app">
    <transition>
      <router-view />
    </transition>
  </div>
</template>

<script>

export default {
  name: 'App',
  data(){
    return{
      
    }
  },
  mounted(){

  },
  methods:{}
}
</script>

<style lang="scss">
html,
body,
#app {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  font-size: calc(100vw / 137);
  // font-size: 14px;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow: hidden;

  .el-tooltip__popper {
    max-width: 800px;
  }
}

.el-form-item {
  margin-bottom: 1.5rem;
}
.el-year-table td .cell{
  color: #fff;
}
.el-picker-panel__icon-btn{
  color: #fff;
}
.el-year-table td.today .cell{
  color: #1890ff ;
  font-weight: bold
}
input::-webkit-outer-spin-button,input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}

.el-notification {
  background: url("./assets/alarm_bg.png") no-repeat;
  background-size: 100% 100%;
}
.el-color-dropdown__btn{ 
  color: #1C4390!important;
  background: none!important;
}
.el-notification__title{
  color: #fff;
}
</style>
